export const checkTBDField = field => (!field || field.trim().toLowerCase() === 'none' ? 'TBD' : field)
